import React, { useEffect } from 'react';
import './styles.css';
import { useLocation } from 'react-router-dom';
import GradientButton from '../customMui/newButton/newButton';
import { withRoomContext } from '../../RoomContext';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

function HostEndedWebinar(props)
{

	const {
		me, webinarSocket
	} = props;

	const location = useLocation();
	const urlData = location.state.state;

	const handleExit=() =>
	{
		if (urlData?.exitUrl)
		{

			if (urlData?.customType)
			{
				window.location.href = urlData?.exitUrl;
			}
			else
			{
				window.location.href = `${urlData?.exitUrl}&uid=${window.btoa(me?.email)}&name=${me?.name}`;
			}
		}

		else
		{
			window.location.href = import.meta.env.VITE_config;
		}
	};

	useEffect(() =>
	{
		if (webinarSocket)
		{
			webinarSocket?.disconnect();
		}

	}, []);

	return (
		<div className='flexCol aCntr hostEndedWebinarPg'>
			<div className='flexRow pdngLG'>
				{/* <img src='/images/inmeet2.png' className='lgH' alt='logo' /> */}
				<img src='/images/inmeet1.png' alt='logo' className='logo' />
			</div>
			<div className='flexMinWidthCol gap16 hostEndedWebinarBody jCntr aCntr '>
				<img src='/images/hostEndedWebinar.svg' alt='hostEndedWebinar' className='engImg' />
				<span className='mHdng textCntr'> Thanks for attending webinar. The host has ended the webinar.</span>
				<GradientButton
					color='primary'
					variant='contained'
					disableElevation
					style={{ borderRadius: '10px' }}
					onClick={handleExit}
				>
					Done
				</GradientButton>
			</div>
		</div>
	);
}

HostEndedWebinar.propTypes =
{
	me            : PropTypes.any,
	webinarSocket : PropTypes.any
};

const mapStateToProps = (state) => ({
	surveyDataStore : state.webinar.surveyDataStore,
	myId            : state.me.id,
	me              : state.me,
	webinarSocket   : state.webinar.webinarSocket

});

// const mapDispatchToProps = (dispatch) => ({

// });

export default withRoomContext(connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.surveyDataStore === next.webinar.surveyDataStore &&
				prev.me.id === next.me.id
			);
		}
	}
)(HostEndedWebinar));